import styled from 'styled-components';
import { ReactComponent as CloseIcon } from "assets/close-small.svg";

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s;
`

export const Container = styled.div`
  width: 25rem;
  height: fit-content;
  background: var(--black-100);
  padding: 2rem;
  position: relative;
`

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`

export const BadgeContainer = styled.div`
  padding: 0.8rem;
  margin: 2rem 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black-300);
  width: 100%;

  span {
    text-align: center;
  }
`

export const DataContainer = styled.div`
  margin-bottom: 35px;

  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 2rem;
  }
`

export const SuperficialPolicemanContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  > span {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    p {
      &:first-of-type {
        color: var(--grey-100);
      
        &:last-of-type {
          font-weight: bold;
          color: white;
        }
      }
    }
  }
`